module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "posta.ge"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/internet/free_email.js
// module id = 1331
// module chunks = 0